import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=f9d2e36c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=f9d2e36c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d2e36c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9d2e36c')) {
      api.createRecord('f9d2e36c', component.options)
    } else {
      api.reload('f9d2e36c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=f9d2e36c&scoped=true&", function () {
      api.rerender('f9d2e36c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24E2I4WRkVN7W/JS/comp/GuestBox.vue"
export default component.exports